/**
 * SOLID Review
 * S — Strong. One concern: the server's health, asked for the banner and the indicator.
 * O — Good. A new health read is one more pass-through.
 * L — N/A — no inheritance hierarchy.
 * I — Strong. Exactly the health op of `ClientUseCases`.
 * D — Strong. One port interface, injected.
 */
import type { IContextRequest } from '../../domain/ports/schemas/ContextRequest';
import type { ICommandNothing } from '../../domain/ports/schemas/TableMoves';
import type { IEntityHealthReport } from '../../domain/ports/schemas/HealthMoves';
import type { IPortClientServerHealth } from '../ports/contracts';
import type { TResult } from '../shared/ClientSteps';

export interface IConfigDepHealthContext {
  readonly health: IPortClientServerHealth;
}

/**
 * THE SERVER'S HEALTH (frontend strict-ports plan, FE5a, 2026-10-04). MaintenanceBanner and HealthIndicator
 * each probed `/health` through the Framework's `HealthAdapter` socket; they ask the Application now. A
 * read with nothing to decide or keep — the two components' thresholds and rendering are their own.
 */
export class HealthContext {
  constructor(private readonly deps: IConfigDepHealthContext) {}

  async checkServerHealth(ctx: IContextRequest, _command: ICommandNothing): Promise<TResult<IEntityHealthReport>> {
    return this.deps.health.probe(ctx);
  }
}
